module.exports = __webpack_public_path__ + "static/media/ic_esign_kyc.a0de97cf.svg";